(() => {
    const SELECTORS = {
        PRICE_GROUP: '.shopping-cart__price-group',
        SUM: '.shopping-cart__sum',
        SUM_MONTHLY: '.shopping-cart__sum--monthly',
        SUM_ONETIME: '.shopping-cart__sum--onetime',
        ROW: '.price-row--option',
        ROW_OPTION: '.price-row--option',
    };

    const formatPrice = (price) => {
        return price.toFixed(2).replace('.', ',') + ' €';
    };

    // Calculate amount for select fields
    const calculatePrice = (price, amount) => {
        amount = parseInt(amount);
        if (isNaN(amount)) amount = 1;
        return amount * price;
    };

    // Recalculates option costs and update shopping cart state
    const recalculateShoppingCart = (shoppingCartState) => {
        const { basePriceMonthly, basePriceOneTime, options, selection } = shoppingCartState;

        // Add all option prices
        const { optionsPriceMonthly, optionsPriceOneTime } = Object.keys(selection).reduce(
            (carry, optionId) => {
                if (!options[optionId]) {
                    console.error(optionId, 'missing in options');
                    return;
                }
                const {
                    properties: { priceMonthly, price },
                } = options[optionId];

                const amount = selection[optionId];

                if (priceMonthly) carry.optionsPriceMonthly += calculatePrice(priceMonthly, amount);
                if (price) carry.optionsPriceOneTime += calculatePrice(price, amount);

                return carry;
            },
            { optionsPriceMonthly: 0, optionsPriceOneTime: 0 }
        );

        // Update sums
        shoppingCartState.optionsPriceMonthly = optionsPriceMonthly;
        shoppingCartState.optionsPriceOneTime = optionsPriceOneTime;
        shoppingCartState.sumMonthly = basePriceMonthly + optionsPriceMonthly;
        shoppingCartState.sumOneTime = basePriceOneTime + optionsPriceOneTime;
    };

    const generatePriceRow = (label, price) => {
        return `
            <tr class="${SELECTORS.ROW.replace('.', '')} ${SELECTORS.ROW_OPTION.replace('.', '')}">
                <td>${label}</td>
                <td>${formatPrice(price)}</td>
            </tr>
        `;
    };

    const refreshShoppingCart = (shoppingCart, shoppingCartState) => {
        const { options, sumMonthly, sumOneTime, selection } = shoppingCartState;
        shoppingCart.querySelectorAll(SELECTORS.ROW).forEach((item) => item.remove());

        const sumMonthlyRow = shoppingCart.querySelector(SELECTORS.SUM_MONTHLY);
        const sumOneTimeRow = shoppingCart.querySelector(SELECTORS.SUM_ONETIME);

        Object.keys(shoppingCartState.selection).forEach((optionId) => {
            const {
                label,
                included,
                properties: { priceMonthly, price },
            } = options[optionId];

            if (!included && priceMonthly < 0 && price < 0) return;

            const amount = selection[optionId];

            if (priceMonthly !== undefined) {
                sumMonthlyRow.insertAdjacentHTML(
                    'beforebegin',
                    generatePriceRow(label.replace(/<span.*span>/g,''), calculatePrice(priceMonthly, amount))
                );
            }
            if (price !== undefined) {
                sumOneTimeRow.insertAdjacentHTML('beforebegin', generatePriceRow(label, calculatePrice(price, amount)));
            }
        });

        sumMonthlyRow.querySelector('td:nth-child(2)').textContent = formatPrice(sumMonthly);
        sumOneTimeRow.querySelector('td:nth-child(2)').textContent = formatPrice(sumOneTime);
    };

    const initShoppingCart = () => {
        if (document.readyState !== 'complete') return;

        const shoppingCart = document.querySelector('.shopping-cart');
        const form = document.querySelector('.product-order form');

        if (!shoppingCart || !form) return;

        const shoppingCartState = JSON.parse(shoppingCart.dataset.formState);

        form.addEventListener('change', (e) => {
            const selectedEntry = e.target;
            let selectedEntryId = selectedEntry.name
                .replace('--' + form.id, '')
                .replace('][', '.')
                .replaceAll(/[\[\]]/g, '');

            //todo: disabled bug
            // const input = document.getElementById(form.id + '-' + selectedEntryId.replace('.','_'));
            // if (input && input.hasAttribute('data-disabled')) {
            //     e.preventDefault();
            //     e.stopPropagation();
            //     input.checked = true;
            //     return;
            // }
            if (!shoppingCartState.options[selectedEntryId] && !shoppingCartState.optionGroups[selectedEntryId]) {
                return;
            }

            const formData = new FormData(form);
            let selectionState = formData.get(selectedEntry.name) || false;

            // Check whether the selection is part of an option group
            if (Object.keys(shoppingCartState.optionGroups).indexOf(selectedEntryId) > -1) {
                // Remove the whole optiongroup as we add the selection again later
                Object.keys(shoppingCartState.selection).forEach((optionId) => {
                    if (optionId.indexOf(selectedEntryId) === 0) {
                        delete shoppingCartState.selection[optionId];
                    }
                });

                // Add selection value to entry id if it's part of an option group
                if (selectionState !== false) {
                    selectedEntryId += '.' + selectionState;
                }
            }

            if (selectionState) {
                // Check for checkboxes and amount selections
                if (selectionState === 'on') {
                    selectionState = true;
                } else if (!isNaN(selectionState)) {
                    selectionState = parseInt(selectionState);
                }
                shoppingCartState.selection[selectedEntryId] = selectionState;
            } else {
                delete shoppingCartState.selection[selectedEntryId];
            }

            recalculateShoppingCart(shoppingCartState);
            refreshShoppingCart(shoppingCart, shoppingCartState);
        });
    };

    const toggleButton = document.getElementById('shopping-cart__yourorder--toggle-js');
    if (toggleButton) {
        toggleButton.addEventListener('click', (e) => {
            const cart = document.getElementById('shopping-cart-js');
            cart.classList.toggle('shopping-cart-wrap--open-js');
        });
    }

    document.addEventListener('readystatechange', initShoppingCart);
})();
